jQuery( 'body' ).ready( function ( $ ) {
  var $selectSeniority  = $( '#search_seniority' );
  var $selectRole       = $( '#search_role' );
  var $selectExpertise  = $( '#search_expertises' );
  let $searchExpertises = '';
  let $searchRole       = '';
  let $searchSeniority  = '';

  $selectRole.on( 'change', function () {
    searchCard( 1, 'role' );
  } );

  $selectSeniority.on( 'change', function () {
    searchCard();
  } );

  $selectExpertise.on( 'change', function () {
    searchCard();
  } );

  $( 'body' ).on( 'click', '.page-number', ( e ) => {
    var pageID = e.currentTarget.id;
    var paged  = $( '#' + pageID ).attr( 'data-page' );

    searchCard( paged );
  } );

  $( 'body' ).on( 'click', '#page-previous', () => {
    var paged = $( '#page-previous' ).attr( 'data-previous' );

    searchCard( paged );
  } );

  $( 'body' ).on( 'click', '#page-next', () => {
    var paged = $( '#page-next' ).attr( 'data-next' );

    searchCard( paged );
  } );

  /**
   * This function performs an ajax query to render the html result on the page.
   *
   * @param pageCurrent current search page.
   * @param selectInput current string select.
   */
  function searchCard( pageCurrent = 1, selectInput = '' ) {

    if ( selectInput === 'role' ) {
      $selectExpertise.val( '' );
      $selectSeniority.val( '' );
    }

    $searchRole = $selectRole.find( 'option:selected' ).attr( 'value' );
    $searchExpertises = $selectExpertise.find( 'option:selected' ).attr( 'value' );
    $searchSeniority  = $selectSeniority.find( 'option:selected' ).attr( 'value' );

    if ( $searchRole.trim().length === 0 ) {
      $selectExpertise.val( '' );
      $selectSeniority.val( '' );
      $selectExpertise.prop( 'disabled', true );
      $selectSeniority.prop( 'disabled', true );
    }

    var $data = {
      action: 'talent_available_ajax',
      paged: pageCurrent,
      role: $searchRole,
      seniority: $searchSeniority,
      expertise: $searchExpertises,
    };

    $.ajax( {
      type: 'POST',
      url: ajax_object.ajax_url,
      data: $data,
      beforeSend: function () {
        $( '.loading-results' ).addClass( 'active' );
        $( '.row-search_talent' ).addClass( 'not-show' );
        $( '.results-not-found' ).addClass( 'not-show' );
      },
    } )
      .complete( function ( response ) {
        $selectExpertise.prop( 'disabled', false );
        $selectSeniority.prop( 'disabled', false );

        $( '.loading-results' ).removeClass( 'active' );
        $( '.row-search_talent' ).removeClass( 'not-show' );
        $( '.results-not-found' ).removeClass( 'not-show' );
        $( '.containers-loading-search' ).html( response ); // CHANGE THIS!

        getRoleElements( $searchSeniority, $searchExpertises );

        if ( $searchRole.trim().length === 0 ) {
          $selectExpertise.prop( 'disabled', true );
          $selectSeniority.prop( 'disabled', true );
        }
      } );
  }

  function getUnique( array ) {
    var uniqueArray = [];

    // Loop through array values
    for ( var value of array ) {
      if ( uniqueArray.indexOf( value ) === -1 ) {
        uniqueArray.push( value );
      }
    }
    return uniqueArray;
  }

  function getRoleElements( searchSeniority, searchExpertises ) {
    var $elementsSeniority       = $( '.container-image-text span' ).map( function () {
      return $( this ).text();
    } ).get();
    var $elementsUniqueSeniority = getUnique( $elementsSeniority );
    var $elementsExpertise       = $( '.expertise-text span' ).map( function () {
      return $( this ).text();
    } ).get();
    var $elementsUniqueExpertise = getUnique( $elementsExpertise );

    $selectSeniority.empty();
    $selectSeniority.append( '<option selected value="">Select Seniority</option>' );
    $.each( $elementsUniqueSeniority, ( key, val ) => {

      if ( searchSeniority === val ) {
        $selectSeniority.append( '<option selected value="' + val + '">' + val + '</option>' );

      } else {
        $selectSeniority.append( '<option value="' + val + '">' + val + '</option>' );
      }
    } );

    $selectExpertise.empty();
    $selectExpertise.append( '<option selected value="">Select Expertise</option>' );
    $.each( $elementsUniqueExpertise, ( key, val ) => {

      if ( searchExpertises === val ) {
        $selectExpertise.append( '<option selected value="' + val + '">' + val + '</option>' );

      } else {
        $selectExpertise.append( '<option value="' + val + '">' + val + '</option>' );
      }
    } );
  }
} );
